var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinantechSlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 46 0 46 46 0 46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06888F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3B4B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESIGN-SYSTEM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Typography-+-Logotipo",
    transform: "translate(-576.000000, -427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(576.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,22.9999567 C0,10.2971145 10.297615,-8.66585409e-05 23,-8.66585409e-05 C35.7028183,-8.66585409e-05 46,10.2971145 46,22.9999567 C46,35.7027989 35.7028183,46 23,46 C10.297615,46 0,35.7027989 0,22.9999567",
    id: "Fill-1",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667383,26 C11.09298,26 11.5200549,25.8370855 11.8450486,25.511673 L24.5118845,12.8451713 C25.1627052,12.1943464 25.1627052,11.1389435 24.5118845,10.4881186 C23.8614806,9.83729379 22.8052512,9.83729379 22.1548472,10.4881186 L9.48842796,23.155037 C8.83719068,23.8054452 8.83719068,24.8612648 9.48842796,25.511673 C9.81342161,25.8370855 10.2404966,26 10.6667383,26",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1549329,21.4881314 L20.4884311,34.1545463 C19.8371896,34.8053881 19.8371896,35.8608185 20.4884311,36.5116603 C20.8138436,36.8370812 21.240088,37 21.6667491,37 C22.0929936,37 22.5200714,36.8370812 22.8450671,36.5116603 L35.5115689,23.8448287 C36.1628104,23.1944036 36.1628104,22.1389732 35.5115689,21.4881314 C34.860744,20.8372895 33.8053411,20.8372895 33.1549329,21.4881314",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6887599,16 C11.1206332,16 11.5533509,15.8349311 11.8826385,15.5052156 L14.5051187,12.8826892 C15.1649604,12.2236803 15.1649604,11.1538989 14.5051187,10.49489 C13.8461214,9.83503668 12.7759367,9.83503668 12.1173615,10.49489 L9.49488127,13.1174163 C8.83503958,13.7764253 8.83503958,14.8462066 9.49488127,15.5052156 C9.82416887,15.8349311 10.2568865,16 10.6887599,16",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1172094,31.4945994 L30.4945907,34.1172642 C29.8351364,34.7763079 29.8351364,35.8461457 30.4945907,36.5051895 C30.8238957,36.8349224 31.2566362,37 31.6885324,37 C32.1208507,37 32.553169,36.8349224 32.882474,36.5051895 L35.5050926,33.8825247 C36.1649691,33.223481 36.1649691,32.1540654 35.5050926,31.4945994 C34.8464827,30.8351335 33.7762415,30.8351335 33.1172094,31.4945994",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2590543,10 L29.5484906,10 C28.5870533,10 27.8075449,10.7795116 27.8075449,11.7409527 C27.8075449,12.7023938 28.5870533,13.4819054 29.5484906,13.4819054 L30.0564115,13.4819054 L9.51020589,34.0281938 C8.82993137,34.7080358 8.82993137,35.8104941 9.51020589,36.4899009 C9.8496903,36.8302571 10.2953724,37 10.7410545,37 C11.1863013,37 11.6324187,36.8302571 11.9719031,36.4899009 L32.5181087,15.9436125 L32.5181087,16.3496897 C32.5181087,17.3111308 33.2976171,18.0906424 34.2590543,18.0906424 C35.2204916,18.0906424 36,17.3111308 36,16.3496897 L36,11.7409527 C36,10.7795116 35.2204916,10 34.2590543,10",
    id: "Fill-12",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinantechSlogo);
export default __webpack_public_path__ + "static/media/FINANTECH_slogo.322b96e2ac79d98c026e0a47299674e7.svg";
export { ForwardRef as ReactComponent };